import { NgModule } from '@angular/core';

import { LocationNamePipe } from '@fcom/locations/pipes';

@NgModule({
  declarations: [LocationNamePipe],
  exports: [LocationNamePipe],
})
export class LocationsPipeModule {}
